import actions from './actions';
import getters from './getters';
import mutations from './mutations';
import { PlatformBrandKitState } from './types';

const state: PlatformBrandKitState = {
  brandKits: [],
  isLoaded: false
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
};
